import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SocketService } from './socket.service';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {

  private baseUrl:any = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private socketService: SocketService
  ) { }

  buildQueryParameters(filters :any) {
    let query = ''

    if (filters.present !== 'Any') {
      query += 'present=' + filters.present.toLowerCase()
    }
    if (filters.booked !== 'Any') {
      query += (query === '' ? '' : '&') + 'booked=' + filters.booked.toLowerCase()
    }
    if (filters.annotated !== 'Any') {
      query += (query === '' ? '' : '&') + 'annotated=' + filters.annotated.toLowerCase()
    }
    if (filters.controlled !== 'Any') {
      query += (query === '' ? '' : '&') + 'controlled=' + filters.controlled.toLowerCase()
    }
    return query === '' ? query : '?' + query
  }

  getOboeDevices(target :any, fields :any, addDevice ?:any) {
    return this.http.get(`${this.baseUrl}`+'/api/v1/devices?target=' + target + '&fields=' + fields);

    // return oboe(this.commonService.getBaseUrl()
    // + '/api/v1/devices?target=' + target + '&fields=' + fields)
    //   .node('devices[*]', function(device) {
    //     addDevice(device)
    //   })
  }

  getDevices(target :any, fields :any) {
    return this.http.get(`${this.baseUrl}` + '/api/v1/devices?target=' + target + '&fields=' + fields);
  }

  getDevice(serial :any, fields :any) {
    return this.http.get(`${this.baseUrl}` + '/api/v1/devices/' + serial + '?fields=' + fields);
  }

  removeDevice(serial :any, filters :any) {
    let buildQueryParameters = this.buildQueryParameters(filters);    
    return this.http.delete(`${this.baseUrl}` + '/api/v1/devices/' + serial + buildQueryParameters)
  }

  removeDevices(filters: any, serials: any) {
    const url = `${this.baseUrl}` + '/api/v1/devices' + this.buildQueryParameters(filters);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    const data = typeof serials === 'undefined' ? serials : JSON.stringify({ serials: serials });

    return this.http.delete(url, { headers, body: data });
  }

  addOriginGroupDevice(id :any, serial :any) {
    return this.http.put(`${this.baseUrl}` + '/api/v1/devices/' + serial + '/groups/' + id, null);
  }

  addOriginGroupDevices(id :any, serials :any) {
    let data = typeof serials === 'undefined' ? serials : JSON.stringify({serials: serials});
    return this.http.put(`${this.baseUrl}` + '/api/v1/devices/groups/' + id + '?fields=""', data);
  }

  removeOriginGroupDevice(id :any, serial :any) {
    return this.http.delete(`${this.baseUrl}` + '/api/v1/devices/' + serial + '/groups/' + id);
  }

  removeOriginGroupDevices(id :any, serials :any) {
    let url = `${this.baseUrl}` + '/api/v1/devices/groups/' + id + '?fields=""';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    let data = typeof serials === 'undefined' ? serials : JSON.stringify({serials: serials});
    return this.http.delete(url, { headers, body: data });
  }

  //<-------------------------------------------check this
  // this.socketService.socket.on('user.settings.devices.created', function(device) {
  //   $rootScope.$broadcast('user.settings.devices.created', device)
  //   $rootScope.$apply()
  // })

  // socket.on('user.settings.devices.deleted', function(device) {
  //   $rootScope.$broadcast('user.settings.devices.deleted', device)
  //   $rootScope.$apply()
  // })

  // socket.on('user.settings.devices.updated', function(device) {
  //   $rootScope.$broadcast('user.settings.devices.updated', device)
  //   $rootScope.$apply()
  // })
}
